import { render } from "./mizelist.vue?vue&type=template&id=b0632524"
import script from "./mizelist.vue?vue&type=script&lang=js"
export * from "./mizelist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__